export enum LeadState {
  NOT_CONTACTED = 'not_contacted',
  INVALID = 'invalid',
  POSITIVE = 'positive',
  REJECTED = 'rejected',
}

export interface BusinessContact {
  id: string
  url: string
  lastmod: string | null
  fetchedAt: string
  httpStatus: number | null
  title: string | null
  description: string | null
  categories: string[] | null
  ogTitle: string | null
  streetAddress: string | null
  locality: string | null
  postalCode: string | null
  countryName: string | null
  emails: string[] | null
  phoneNumbers: string[] | null
  websites: string[] | null
  latitude: number | null
  longitude: number | null
  note: string | null
  state: LeadState
  createdAt: string
  updatedAt: string
  deletedAt: string | null
}

export interface BusinessContactResponse {
  success: boolean
  data: BusinessContact[]
  pagination: BusinessContactPagination
}

export interface BusinessContactPagination {
  page: number
  pageSize: number
  total: number
  totalPages: number
}

export interface BusinessContactQueryParams {
  page?: number
  pageSize?: number
  orderBy?: string
  search?: string
  state?: LeadState
  locality?: string
  postalCode?: string
}

export interface BusinessContactErrorResponse {
  error: string
  message?: string
}

export const leadStateLabels: Record<LeadState, string> = {
  [LeadState.NOT_CONTACTED]: 'Nekontaktováno',
  [LeadState.INVALID]: 'Neplatný',
  [LeadState.POSITIVE]: 'Pozitivní',
  [LeadState.REJECTED]: 'Odmítnuto',
}

export const leadStateColors: Record<LeadState, string> = {
  [LeadState.NOT_CONTACTED]: 'default',
  [LeadState.INVALID]: 'error',
  [LeadState.POSITIVE]: 'success',
  [LeadState.REJECTED]: 'warning',
}
